export const ShieldOffIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '30'}
    height={props?.height || '30'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M19 14V5.54054L11.5 3L8.5 4M4 8V12.0569C4 14.4506 5.07187 16.7185 6.92137 18.2381L11.5 22L14 19.9459"
        stroke={props?.color || '#333333'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{' '}
      <line
        x1="3.4137"
        y1="3.03821"
        x2="20.0382"
        y2="20.5863"
        stroke={props?.color || '#333333'}
        strokeWidth="2"
        strokeLinecap="round"
      ></line>{' '}
    </g>
  </svg>
);
